import React, { useState, useEffect } from 'react';
import { Container, Table, Button, Modal, Form, Badge, Card, Row, Col, Dropdown, DropdownButton, Spinner, Image } from 'react-bootstrap';
import Select from 'react-select';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPropertysAll, fetchPropertysAllByOwnerId, fetchPropertysFilters } from '../../../actions/request/PropertyRequest';
import { fetchVehiclesAll, fetchVehiclesAllByOwnerId, fetchVehiclesAllFilter } from '../../../actions/request/VehicleRequest';
import { fetchMaintenancesAll, MaintenanceCreate, MaintenanceCancelById, MaintenanceDeleteById, MaintenanceUpdateById } from '../../../actions/request/MaintenanceRequest';
import { toast } from 'react-toastify';
import { getAndCheckLocalStorage } from '../../../utils/storage/localvalueFuction';
import { localStorageKeys } from '../../../utils/storage/localvalue';
import moment from 'moment';
import { fetchMotifsAll } from '../../../actions/request/MotifRequest';
import { MdColorize, MdDeleteOutline, MdMap, MdOutlineSearch } from 'react-icons/md';
import { emptyImage, profileRoleType } from '../../../utils/dataApi/dataFormApi';
import { fetchMaintenanceCategorysAll } from '../../../actions/request/MaintenanceCategoryRequest';
import { fetchCategoryExpenseBigsAll } from '../../../actions/request/CategoryExpnsesBigRequest';

const MaintenanceManagementPage = () => {
    const dispatch = useDispatch();
    const maintenanceCategorys = useSelector((state) => state.maintenanceCategorys.maintenanceCategorys);
    const vehicles = useSelector((state) => state.vehicles.vehicles);
    const propertys = useSelector((state) => state.propertys.propertys);
    const maintenancesData = useSelector((state) => state.maintenances.maintenances);
    const loadingMaintenance = useSelector((state) => state.maintenances.loadingMaintenance);
    // const maintenanceCategorys = useSelector((state) => state.maintenanceCategorys.maintenanceCategorys);

    const [maintenanceCategorySelect, setmaintenanceCategorySelect] = useState(null);
    const [vehicleSelect, setvehicleSelect] = useState(null);
    const [propertySelect, setpropertySelect] = useState(null);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [description, setDescription] = useState('');
    const [cost, setCost] = useState(0); // Ajout du champ coût
    const [showModal, setShowModal] = useState(false);
    const [modalAction, setModalAction] = useState('add'); // add, cancel, delete
    const [selectedMaintenance, setSelectedMaintenance] = useState(null);
    const [idMaintenance, setidMaintenance] = useState("");
    const [categorySelect, setcategorySelect] = useState(null);



    const categoryexpensebigs = useSelector((state) => state.categoryexpensebigs.categoryexpensebigs);
    const callFunctionElements = () => {
        setvehicleSelect("")
        setpropertySelect("")
        setstartDateSearch("")
        setendDateSearch("")
        const userId = getAndCheckLocalStorage(localStorageKeys.userId);
        if (getAndCheckLocalStorage(localStorageKeys.profileRole) === profileRoleType.USER) {
            dispatch(fetchMaintenancesAll(getAndCheckLocalStorage(localStorageKeys.userId)));
            dispatch(fetchMaintenanceCategorysAll());
            dispatch(fetchPropertysAllByOwnerId(getAndCheckLocalStorage(localStorageKeys.userId)));
            dispatch(fetchVehiclesAllByOwnerId(getAndCheckLocalStorage(localStorageKeys.userId)));
            dispatch(fetchMotifsAll());
            dispatch(fetchCategoryExpenseBigsAll("", true));


        } else if (getAndCheckLocalStorage(localStorageKeys.profileRole) === profileRoleType.CUSTOMER) {
        }
        else {
            dispatch(fetchMaintenancesAll());
            dispatch(fetchPropertysFilters());
            dispatch(fetchVehiclesAllFilter());
            dispatch(fetchCategoryExpenseBigsAll("", true));

        }
    }


    useEffect(() => {
        callFunctionElements()
    }, [dispatch]);

    // Filtre des options
    const maintenanceCategoryOptionsV = maintenanceCategorys?.filter((item) => item.patrimoine == "VEHICLE")?.map(item => ({ value: item._id, label: item.name, patrimoine: item.patrimoine })) || [];
    const maintenanceCategoryOptionsP = maintenanceCategorys?.filter((item) => item.patrimoine == "PROPERTY")?.map(item => ({ value: item._id, label: item.name, patrimoine: item.patrimoine })) || [];
    const categoryexpensebigsOptions = categoryexpensebigs?.filter((item) => item.maintenance == true)?.map(item => ({ value: item._id, label: item.name })) || [];
    const vehicleOptions = vehicles?.map(item => ({ value: item?._id, label: item?.brand, images: item?.images, color: item?.color, model: item?.model })) || [];
    const propertyOptions = propertys?.map(item => ({ value: item?._id, label: item?.name, images: item?.images, address: item?.address })) || [];

    // Fonction pour ouvrir le modal d'ajout ou d'action
    const handleModal = (action, maintenance = null) => {
        setModalAction(action);
        setSelectedMaintenance(maintenance);
        setShowModal(true);
        if (maintenance) {
            // console.log(maintenance);

            setidMaintenance(maintenance._id);
            setmaintenanceCategorySelect({ value: maintenance.category?._id, label: maintenance.category?.name });
            setCost(Number(maintenance?.cost || 0));
            setDescription(maintenance?.description);
            setStartDate(moment(maintenance?.startDate).format("YYYY-MM-DD"));
            setEndDate(moment(maintenance?.endDate).format("YYYY-MM-DD"));
            if (maintenance && maintenance.property) {
                setpropertySelect({ value: maintenance.property?._id, label: maintenance.property?.name, name: maintenance.property?.name, images: maintenance.property?.images, address: maintenance.property?.address });
            } else if (maintenance && maintenance.vehicle) {
                setvehicleSelect({ value: maintenance.vehicle?._id, label: maintenance.vehicle?.brand, brand: maintenance.vehicle?.brand, images: maintenance.vehicle?.images, color: maintenance?.vehicle?.color, model: maintenance?.model });
            } else {
                setpropertySelect(null);
                setvehicleSelect(null);
            }
        }
    };



    const renderStatusBadge = (status) => {
        switch (status) {

            case 'PLANNED':
                return <Badge bg="success">Planifié</Badge>;
            case 'PENDING':
                return <Badge bg="warning">En attente</Badge>;
            case 'CONFIRMED':
                return <Badge bg="success">Confirmée</Badge>;
            case 'CANCELLED':
                return <Badge bg="danger">Annulée</Badge>;
            case 'COMPLETED':
                return <Badge bg="primary">Terminée</Badge>;

            default:
                return <Badge bg="secondary">{status}</Badge>;
        }
    };



    // gestion des assurances en question
    const handleChangeParse = (e) => {
        const { value } = e.target;
        const parsedValue = parseFloat(value);
        setCost(parsedValue >= 0 ? value : 0);
    };



    // Griser les dates passées
    const minStartDate = moment().format('YYYY-MM-DD');

    // Griser les dates avant la date de début + 2 jours
    const minEndDate = startDate ? moment(startDate).add(2, 'days').format('YYYY-MM-DD') : '';

    // Validation des champs avant soumission
    const validateForm = () => {
        if (!maintenanceCategorySelect?.value && !startDate && !endDate && !description || (!vehicleSelect || !propertySelect) && !maintenanceCategorySelect && !cost) {
            toast.error('Tous les champs doivent être remplis');
            return false;
        }
        const start = new Date(startDate);
        const end = new Date(endDate);

        // if (start < new Date()) {
        //     toast.error("La date de début ne peut pas être dans le passé ou celle d'aujourd'hui");
        //     return false;
        // }
        if ((end - start) / (1000 * 60 * 60 * 24) < 2) {
            toast.error("La date de fin doit être au moins deux jours après la date de début.");
            return false;
        }
        return true;
    };

    // Fonction pour soumettre les actions
    const handleSubmitAction = () => {
        if (modalAction === 'add') {
            if (!validateForm()) return;
            const data = {
                category: maintenanceCategorySelect?.value,
                property: propertySelect?.value,
                vehicle: vehicleSelect?.value,
                description,
                startDate,
                endDate,
                cost: Number(cost), // Enregistrer le coût en tant que nombre
                userAdd: getAndCheckLocalStorage(localStorageKeys.userId)
            };
            dispatch(MaintenanceCreate(data, toast));
            dispatch(fetchMaintenancesAll(getAndCheckLocalStorage(localStorageKeys.userId)))
            setShowModal(false);
        }
        else if (modalAction === 'edit') {
            if (!validateForm()) return;
            const data = {
                category: maintenanceCategorySelect?.value,
                property: propertySelect?.value,
                vehicle: vehicleSelect?.value,
                description,
                startDate,
                endDate,
                cost: Number(cost), // Enregistrer le coût en tant que nombre
                userAdd: getAndCheckLocalStorage(localStorageKeys.userId)
            };
            dispatch(MaintenanceUpdateById(idMaintenance, data, toast));
            dispatch(fetchMaintenancesAll(getAndCheckLocalStorage(localStorageKeys.userId)))
            setShowModal(false);
        }
        else if (modalAction === 'cancel') {
            dispatch(MaintenanceCancelById(selectedMaintenance._id, toast));
            dispatch(fetchMaintenancesAll(getAndCheckLocalStorage(localStorageKeys.userId)))
        } else if (modalAction === 'delete') {
            dispatch(MaintenanceDeleteById(selectedMaintenance._id, toast));
            dispatch(fetchMaintenancesAll(getAndCheckLocalStorage(localStorageKeys.userId)))
        }
        setShowModal(false);
    };

    const [startDateSearch, setstartDateSearch] = useState('');
    const [endDateSearch, setendDateSearch] = useState('');
    const handleFilter = () => {
        if (getAndCheckLocalStorage(localStorageKeys.profileRole) === profileRoleType.USER) {

            dispatch(fetchMaintenancesAll(getAndCheckLocalStorage(localStorageKeys.userId), startDateSearch, endDateSearch, propertySelect?.value, vehicleSelect?.value, ""));

        } else if (getAndCheckLocalStorage(localStorageKeys.profileRole) === profileRoleType.CUSTOMER) {
        }
        else {
            dispatch(fetchMaintenancesAll("", startDateSearch, endDateSearch, propertySelect?.value, vehicleSelect?.value, ""));
        }

    };

    return (
        <div>
            <Card>
                <Card.Header>
                    <div style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
                        <div>
                            <h3 className="mb-4">Entretiens et réparations</h3>
                        </div>
                        <div>
                            {
                                getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.USER ?

                                    loadingMaintenance ?
                                        <Button variant="primary" size="sm" ><Spinner variant="light" /></Button>
                                        :
                                        <Button variant="primary" size='sm' className="ml-2" onClick={() => {
                                            handleModal("add");
                                            setpropertySelect(null)
                                            setvehicleSelect(null)
                                            setmaintenanceCategorySelect(null)
                                            setDescription("")
                                            setStartDate("")
                                            setEndDate("")
                                            setCost(0)
                                        }}>+ Ajouter</Button> : ""
                            }
                        </div>
                    </div>
                </Card.Header>

                <Card.Body>
                    <>
                        <ul className="list-group">
                            <li className="list-group-item" style={{ display: "flex", flexWrap: "wrap", width: "100%", justifyContent: "space-between" }}>
                                <div className="flex" style={{ display: "flex", flexWrap: "wrap", maxWidth: "100%" }}>
                                    <Form>
                                        <Row>


                                            <Col md={6}>
                                                <Form.Group controlId="startHour" style={{ minWidth: "200px" }}>
                                                    <Form.Label>Véhicule</Form.Label>
                                                    <Select
                                                        value={vehicleSelect}
                                                        onChange={(selectedOption) => setvehicleSelect(selectedOption)}
                                                        options={vehicleOptions}
                                                        isClearable
                                                        isSearchable
                                                        placeholder="Choix"
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group controlId="startHour" style={{ minWidth: "200px" }}>
                                                    <Form.Label>Propriété</Form.Label>
                                                    <Select
                                                        value={propertySelect}
                                                        isClearable
                                                        isSearchable
                                                        onChange={(selectedOption) => setpropertySelect(selectedOption)}
                                                        options={propertyOptions}
                                                        placeholder="Choix"
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </Form>

                                </div>
                                <div style={{ display: "flex", flexWrap: "wrap" }}>
                                    <div className="p-1">
                                        <label>{"Début"}</label>
                                        <input type="date" style={{ height: "40px" }} placeholder='début' className="form-control" value={startDateSearch} onChange={(e) => setstartDateSearch(e.target.value)} />
                                    </div>
                                    <div className="p-1">
                                        <label>{"Fin"}</label>
                                        <input type="date" style={{ height: "40px" }} placeholder='fin' className="form-control" value={endDateSearch} onChange={(e) => setendDateSearch(e.target.value)} />
                                    </div>
                                    <div className="m-1">
                                        <label>{""}</label>
                                        <div>
                                            <Button variant='primary' size='sm' className="m-1" onClick={handleFilter} >
                                                <MdOutlineSearch />
                                            </Button>
                                            {
                                                (
                                                    vehicleSelect || propertySelect || startDateSearch || endDateSearch
                                                ) && (
                                                    <Button variant="danger" size="sm" className="m-1 text-white" onClick={callFunctionElements}>
                                                        <MdDeleteOutline /> Effacer
                                                    </Button>
                                                )
                                            }
                                        </div>

                                    </div>

                                </div>
                            </li>
                        </ul>
                    </>

                    <div style={{ minHeight: "500px" }} >
                        {maintenancesData?.length === 0 ? (
                            <p className="text-center mt-5">Aucun enregistré</p>
                        ) : (
                            <Table striped responsive hover className="mt-4">
                                <thead>
                                    <tr>
                                        <th>Photo</th>
                                        <th>Motif</th>
                                        <th>Type</th>
                                        <th>Patrimoine</th>
                                        <th>Début</th>
                                        <th>Fin</th>
                                        <th>Statut</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {maintenancesData.map(maintenance => (
                                        <tr key={maintenance._id}>
                                            <td>
                                                {maintenance.property?.images?.[0] ? (
                                                    <img className="rounded-md" src={maintenance.property.images[0] || emptyImage} alt="Propriété" style={{ height: '70px', width: "70px" }} />
                                                ) : (
                                                    maintenance.vehicle?.images?.[0] && <img className="rounded-md" src={maintenance.vehicle.images[0] || emptyImage} alt="Véhicule" style={{ height: '70px', width: "70px" }} />
                                                )}
                                            </td>
                                            <td>{maintenance.category?.name}</td>
                                            <td>{maintenance.vehicle ? 'Véhicule' : 'Propriété'}</td>
                                            <td>{maintenance.property?.name || maintenance.vehicle?.brand}</td>
                                            <td>{moment(maintenance.startDate).format('DD-MM-YYYY')}</td>
                                            <td>{moment(maintenance.endDate).format('DD-MM-YYYY')}</td>
                                            <td>{renderStatusBadge(maintenance.status)}</td>
                                            <td>
                                                <DropdownButton id="dropdown-basic-button" title="Actions" size="sm">
                                                    {
                                                        getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.USER &&
                                                            getAndCheckLocalStorage(localStorageKeys.userId) == maintenance?.userAdd?._id ?
                                                            <>
                                                                {
                                                                    (maintenance?.status == "CREATED" || maintenance?.status == "PLANNED") && (
                                                                        <Dropdown.Item onClick={() => handleModal('edit', maintenance)}>Modifier</Dropdown.Item>
                                                                    )
                                                                }
                                                                {
                                                                    (maintenance?.status == "CANCELLED") && (
                                                                        <Dropdown.Item onClick={() => handleModal('delete', maintenance)}>Supprimer</Dropdown.Item>
                                                                    )
                                                                }
                                                                {
                                                                    (maintenance?.status == "PLANNED") && (<Dropdown.Item onClick={() => handleModal('cancel', maintenance)}>Annuler</Dropdown.Item>)
                                                                }
                                                            </>
                                                            : ""
                                                    }
                                                </DropdownButton>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        )}
                    </div>

                    {/* Modal pour les actions de maintenance */}
                    <Modal show={showModal} size='lg' onHide={() => setShowModal(false)} centered>
                        <Modal.Header closeButton>
                            <Modal.Title>{modalAction === 'add' ? 'Nouvelle maintenance' : modalAction === 'edit' ? 'Modifier cette maintenance' : modalAction === 'cancel' ? 'Annuler' : 'Supprimer la maintenance'}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>

                            <Row>
                                {
                                    (modalAction == 'add' || modalAction == 'edit' || modalAction == "delete" || modalAction == "cancel") ?
                                        (vehicleSelect?.value || propertySelect?.value) ?
                                            (<Col md={12}>
                                                <div className="card" style={{ width: "100%" }}>
                                                    <div className="card-body">

                                                        <Row>
                                                            <Col md={2}>
                                                                {vehicleSelect?.images && vehicleSelect?.images.length > 0 ? (
                                                                    <Image
                                                                        src={vehicleSelect?.images[0] || emptyImage}
                                                                        className="img-fluid rounded-md"
                                                                        style={{ width: "100px", height: "100px" }}
                                                                        alt={vehicleSelect?.label || ""}
                                                                    />
                                                                ) : ""}

                                                                {
                                                                    propertySelect?.images && propertySelect?.images.length > 0 ? (
                                                                        <Image
                                                                            src={propertySelect?.images[0] || emptyImage}
                                                                            className="img-fluid rounded-md"
                                                                            style={{ width: "100px", height: "100px" }}
                                                                            alt={propertySelect?.label || ""}
                                                                        />
                                                                    ) : ""}
                                                            </Col>
                                                            <Col md={10}>
                                                                <ul className="list-group list-group-flush">
                                                                    {vehicleSelect?.brand && (
                                                                        <li className="list-group-item">{vehicleSelect?.brand}</li>
                                                                    )}
                                                                    {vehicleSelect?.model && (
                                                                        <li className="list-group-item">Model : {vehicleSelect?.model}</li>
                                                                    )}
                                                                    {vehicleSelect?.color && (
                                                                        <li className="list-group-item">
                                                                            <MdColorize /> {vehicleSelect?.color}
                                                                        </li>
                                                                    )}
                                                                    {propertySelect?.label && (
                                                                        <li className="list-group-item">Titre : {propertySelect?.label}</li>
                                                                    )}
                                                                    {propertySelect?.address && (
                                                                        <li className="list-group-item">
                                                                            <MdMap /> {propertySelect?.address}
                                                                        </li>
                                                                    )}


                                                                </ul>
                                                            </Col>
                                                        </Row>

                                                    </div>
                                                </div>
                                            </Col>
                                            ) : "" : ""
                                }

                                {(modalAction === 'add' || modalAction === 'edit') && (
                                    <>




                                        {
                                            modalAction === 'add' && (
                                                <Col md={4}>
                                                    <Form.Group>
                                                        <Form.Label>Categorie <span className="text-danger">*</span></Form.Label>
                                                        <Select
                                                            value={categorySelect}
                                                            onChange={(options) => { setcategorySelect(options); fetchMaintenanceCategorysAll(options?.value) }}
                                                            options={categoryexpensebigsOptions}
                                                            isClearable
                                                            placeholder="Choix"
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            )
                                        }

                                        {
                                            (categorySelect || vehicleSelect || propertySelect) && (
                                                <Col md={4}>
                                                    <Form.Group>
                                                        <Form.Label>Motif <span className="text-danger">*</span></Form.Label>
                                                        <Select
                                                            value={maintenanceCategorySelect}
                                                            onChange={setmaintenanceCategorySelect}
                                                            options={vehicleSelect ? maintenanceCategoryOptionsV : maintenanceCategoryOptionsP}
                                                            isClearable
                                                            placeholder="Choix"
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            )
                                        }



                                        {
                                            modalAction === 'add' && (
                                                <Col md={4}>
                                                    <Form.Group>
                                                        <Form.Label>Véhicule <span className="text-danger">*</span></Form.Label>
                                                        <Select

                                                            value={vehicleSelect}
                                                            onChange={(options) => { setvehicleSelect(options); }}
                                                            options={vehicleOptions}
                                                            isClearable
                                                            placeholder="Choix"
                                                            isDisabled={!!propertySelect}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            )
                                        }


                                        {
                                            modalAction === 'add' && (
                                                <Col md={4}>
                                                    <Form.Group>
                                                        <Form.Label>Propriété <span className="text-danger">*</span></Form.Label>
                                                        <Select
                                                            readOnlly={modalAction === 'add' ? false : true}
                                                            value={propertySelect}
                                                            onChange={(options) => { setpropertySelect(options); }}
                                                            options={propertyOptions}
                                                            isClearable
                                                            placeholder="Choix"
                                                            isDisabled={!!vehicleSelect}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            )
                                        }


                                        <Col md={modalAction === 'add' ? 6 : 4}>
                                            <Form.Group>
                                                <Form.Label>Date de début <span className="text-danger">*</span></Form.Label>
                                                <Form.Control
                                                    style={{ height: "40px" }}
                                                    type="date"
                                                    placeholder="debut"
                                                    value={startDate}
                                                    // min={minStartDate}
                                                    // Griser les dates passées
                                                    onChange={(e) => setStartDate(e.target.value)}
                                                />
                                            </Form.Group>
                                        </Col>

                                        <Col md={modalAction === 'add' ? 6 : 4}>
                                            <Form.Group>
                                                <Form.Label>Date de fin <span className="text-danger">*</span></Form.Label>
                                                <Form.Control
                                                    style={{ height: "40px" }}
                                                    type="date"
                                                    placeholder="fin"
                                                    value={endDate}
                                                    min={minEndDate}
                                                    // Griser les dates avant 2 jours après la date de début
                                                    onChange={(e) => setEndDate(e.target.value)}
                                                />
                                            </Form.Group>
                                        </Col>

                                        <Col md={12}>
                                            <Form.Group>
                                                <Form.Label>Coût <span className="text-danger">*</span></Form.Label>
                                                <Form.Control
                                                    style={{ height: "40px" }}
                                                    type="number"
                                                    min={0}
                                                    value={cost}
                                                    onChange={handleChangeParse}
                                                    placeholder=""
                                                />
                                            </Form.Group>
                                        </Col>

                                        <Col md={12}>
                                            <Form.Group>
                                                <Form.Label>Description <span className="text-danger">*</span></Form.Label>
                                                <Form.Control
                                                    as="textarea"
                                                    rows={2}
                                                    value={description}
                                                    onChange={(e) => setDescription(e.target.value)}
                                                    placeholder=""
                                                />
                                            </Form.Group>
                                        </Col>
                                    </>
                                )}
                            </Row>

                            <p className="text-center">{modalAction === 'cancel' && 'Êtes-vous sûr de vouloir annuler cette maintenance ?'}</p>
                            <p className="text-center">{modalAction === 'delete' && 'Êtes-vous sûr de vouloir supprimer cette maintenance ?'}</p>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="light" size="sm" onClick={() => setShowModal(false)}>Fermer</Button>
                            {
                                loadingMaintenance ?
                                    <Button variant="primary" size="sm" ><Spinner variant="light" /></Button>
                                    :
                                    <Button variant="primary" size="sm" onClick={handleSubmitAction}>{modalAction === 'add' ? 'Ajouter' : modalAction === 'edit' ? 'Mettre à jour' : modalAction === 'cancel' ? 'Annuler' : 'Supprimer'}</Button>
                            }
                        </Modal.Footer>
                    </Modal>
                </Card.Body>
            </Card>
        </div>
    );
};

export default MaintenanceManagementPage;
